
<div mat-dialog-title>Select scheduled rebalances for this portfolio<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>
  <div class="include-portfolio-in-scheduled-rebalance-component" id="include-portfolio-in-scheduled-rebalance-component">
    <div style="border-bottom:1px solid #ccc !important; margin-bottom:10px; padding-bottom:10px;">
      <div class="bold">{{"Portfolio: "+ portfolioName}}</div>
    </div>
    <div>Select which existing rebalances you want this portfolio to be included in.</div>
  </div>

  @if (!isUiTest) {
    <irb-inventory-grid
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      [style.minHeight]="'350px'"
      [style.height]="'400px'"
      [componentName]="'includeInScheduledRebalanceDialog'"
      [sideBar]="sideBar"
      [footerContent] = "footerContent"
      [loadingOverlayComponent]="'customLoadingOverlay'"
      [loadingOverlayComponentParams]="loadingOverlayComponentParams"
    ></irb-inventory-grid>
  }</mat-dialog-content>
  <mat-dialog-actions>
    <button  id="closeButton" (click)="close()" class="btn-medium-secondary">Close</button>
    <button  id="proceedButton" (click)="proceed()" class="btn-medium-primary" [disabled]="disableActionBtn">Proceed</button>
  </mat-dialog-actions>
